import { useBadges } from "api/badges";

export const BadgeNameReadOnly = ({
  badgeTypeId,
}: {
  badgeTypeId?: string;
}) => {
  const { useBadgeDetails } = useBadges();
  const { data: badge } = useBadgeDetails(badgeTypeId);

  return <span>{badge?.name}</span>;
};
